export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtStanoviste';
export const NAME = 'Stanoviste';
